/**
 * @file paddle hack register
 * @author wanzhongyun
 */

import './style.less';


const HackRegister = (props:any) => {

    const {
        describe,
        introduce,
        titleImageUrl,
        register,
        registerLink,
        joinCom,
        joinComLink
    } = props;
    
    return (
        <div className='paddle-hack-register-f-wrapper'>
            <div className='paddle-hack-registe-content'>
                <img className='paddle-hack-time-line-title' src={titleImageUrl} alt='' />
                <div className='paddle-hack-time-line-introduce'>{introduce ?? ""}</div>
                <div className='paddle-hack-time-line-desc'>{describe ?? ""}</div>
                <div className='paddle-hack-register-f-btn-wrapper'>
                    <a href={registerLink} target='_blank' rel='noreferrer'>
                        <div className='register-btn'>{register}</div>
                    </a>
                    <a href={joinComLink} target='_blank' rel='noreferrer'>
                        <div className='detail-btn'>{joinCom}</div>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default HackRegister;